/* @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement } from 'react';

import {
  Button,
  Container,
  Grid,
  Paragraph,
  Link,
  GridItem,
  ButtonPattern,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import PageHeading from 'components/pageHeading/PageHeading';

import { TriageDeviceSwitchContent } from './TriageDeviceSwitchContent';
import StyledBox from '../../components/style/styledBox/StyledBox';
import { StyledImage } from '../fullSignatoryPage/FullSignatoryPage.styled';

function TriageDeviceSwitch(): ReactElement {
  const { triageDeviceSwitchContent } = useContent<TriageDeviceSwitchContent>();
  const navigate = useNavigate();

  const handleNavigation = (path: string): void => {
    navigate(path);
  };

  return (
    <Container padding="none">
      {triageDeviceSwitchContent &&
        triageDeviceSwitchContent.map(
          ({
            serviceName,
            header,
            content,
            imageSrc,
            imageAltText,
            yesBtnHref,
            yesBtn,
            noBtnHref,
            noBtn,
            previousLink,
            previousHref,
          }) => (
            <React.Fragment key="content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="center" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Grid alignX="center" alignY="center">
                      <GridItem>
                        <Paragraph>{content}</Paragraph>
                      </GridItem>
                      <GridItem sm={12} md={6} lg={6}>
                        <Container marginBottom="05">
                          <StyledImage alt={imageAltText} src={imageSrc} />
                        </Container>
                      </GridItem>
                      <GridItem>
                        <ButtonPattern marginBottom="none">
                          <Button
                            variation="secondary"
                            onClick={() => handleNavigation(yesBtnHref)}
                          >
                            {yesBtn}
                          </Button>
                          <Button
                            variation="secondary"
                            onClick={() => handleNavigation(noBtnHref)}
                          >
                            {noBtn}
                          </Button>
                          <Link
                            iconPosition="left"
                            onClick={() => handleNavigation(previousHref)}
                          >
                            {previousLink}
                          </Link>
                        </ButtonPattern>
                      </GridItem>
                    </Grid>
                  </StyledBox>
                </GridItem>

                <GridItem lg={4}>
                  {/* FAQs accordian */}
                  <Grid>
                    <GridItem>
                      <NeedHelpWrapper />
                    </GridItem>
                  </Grid>
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}

export default TriageDeviceSwitch;
